import { ComponentProps } from 'react';
import { Input as AriaInput } from 'react-aria-components';

import {
  licensePlateContainerVariants,
  licensePlateCountryContainerVariants,
  licensePlateCountryVariants,
  licensePlateInputVariants,
  LicensePlateSizeVariants,
} from './license-plate.variants';
import { twMerge } from 'tailwind-merge';

export type Props = {
  className?: string;
} & LicensePlateSizeVariants &
  Omit<ComponentProps<typeof AriaInput>, 'className'>;

export function LicensePlate(props: Props) {
  const { size, className, ...rest } = props;

  return (
    <div
      className={twMerge(licensePlateContainerVariants({ size }), className)}
    >
      <div className={licensePlateCountryContainerVariants({ size })}>
        <div className="relative flex items-center justify-center h-full">
          <img
            src="/images/license-plate/nl.svg"
            alt="dwada"
            className={licensePlateCountryVariants({ size })}
          />
        </div>
      </div>

      <div className="relative flex-1">
        {/* Hidden div to measure text width */}
        <div
          className={twMerge(
            licensePlateInputVariants({ size }),
            'invisible whitespace-pre',
          )}
        >
          {` ${rest.value}`}
        </div>

        <AriaInput
          placeholder=". .-. .-. ."
          className={twMerge(
            licensePlateInputVariants({ size }),
            'absolute inset-0',
          )}
          {...rest}
        />
      </div>
    </div>
  );
}
